import { NotificationType } from '@routific/hive';
import i18n from '../../i18n';

export const assignStopsFailedNotification = (solutionId: string, count: number) => ({
  id: `assign-stops-${solutionId}-failure`,
  type: NotificationType.ERROR,
  message: i18n.t('notifications:moveVisits.failure.message', { count }),
  dataCy: 'assign-stop-message-failure',
});

export const noRoutesToInsertNotification = (id: string, count: number) => ({
  id: `assign-stops-${id}-no-routes`,
  type: NotificationType.WARNING,
  message: i18n.t('notifications:moveVisits.noRoutesToInsert.message', { count }),
  dataCy: 'assign-stop-message-no-routes',
});

export const noOrdersToScheduleNotification = (id: string) => ({
  id: `assign-stops-${id}-no-orders`,
  type: NotificationType.WARNING,
  message: i18n.t('notifications:moveVisits.noOrdersToSchedule.message'),
  dataCy: 'assign-stop-message-no-orders',
});

export const assignStopsSuccessNotification = (solutionId: string, count: number) => ({
  id: `assign-stop-${solutionId}-success`,
  type: NotificationType.SUCCESS,
  message: i18n.t('notifications:moveVisits.success.message', { count }),
  dataCy: 'assign-stop-message-success',
});
